import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { TagadaPayConfigurationCard } from './components/tagadapay-configuration-card'
import { TagadaPayDescriptorCard } from './components/tagadapay-descriptor-card'
import { TagadaPayFeaturesCard } from './components/tagadapay-features-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface TagadaPayProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const TagadaPayProcessorDetailsPage = ({ processor }: TagadaPayProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="tagadapay"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <TagadaPayConfigurationCard processor={processor} />
            <TagadaPayDescriptorCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <TagadaPayFeaturesCard />
        </>
    )
}

